"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Field_1 = __importDefault(require("../../componentReusable/Field"));
const styled_components_1 = require("styled-components");
const AppContextProvider_1 = require("../../contexts/AppContextProvider");
const helpers_1 = require("../../helpers");
const FakedCheckbox_1 = __importDefault(require("../../componentReusable/FakedCheckbox"));
const validateLogin_1 = require("../../dataLayer/apisWithoutCache/slr/validateLogin");
const cookiesMember_1 = require("../../dataLayer/cookiesAndLocalStorage/cookiesMember");
const constants_1 = require("../../constants");
const onKeyPress_1 = __importDefault(require("../../utils/misc/onKeyPress"));
const localStorageUtility_1 = __importDefault(require("../../hooks/localStorageUtility"));
const useTrackPageView_1 = __importDefault(require("../../GTMs/useTrackPageView"));
const slrActions_1 = require("../../GTMs/actions/slrActions");
const slrActions_2 = require("../../libs/loggingAPIs/actions/slrActions");
const helpers_2 = require("../../libs/loggingAPIs/helpers");
const useScreenLoadLogging_1 = __importDefault(require("../../hooks/useScreenLoadLogging"));
const loggingTypes_1 = require("../../libs/logging/types/loggingTypes");
const loggingActions_1 = require("../../libs/logging/helpers/loggingActions");
const { setItem: setLocalStorage } = (0, localStorageUtility_1.default)();
const PasswordScreen = ({ ssoConfiguration }) => {
    const [error, setError] = (0, react_1.useState)("");
    const [password, setPassWord] = (0, react_1.useState)("");
    const [checked, setChecked] = (0, react_1.useState)(true);
    const { translations, isDesktop, isMobile } = (0, styled_components_1.useTheme)();
    const { flowState, dispatch } = (0, AppContextProvider_1.useSsoContext)();
    (0, useTrackPageView_1.default)("slrLoginScreen", true, true);
    (0, useScreenLoadLogging_1.default)(loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_LOGIN);
    (0, react_1.useEffect)(() => { });
    const onSubmitLogin = () => {
        const body = {
            LoginModel: {
                username: flowState.phone,
                password: password,
            },
            country_code: flowState.country.phone_code,
        };
        (0, loggingActions_1.authenticateLoginSubmitAction)();
        (0, validateLogin_1.postValidateLoginCredential)(body).then(onSuccessLogin).catch((e) => {
            setError(e && (e === null || e === void 0 ? void 0 : e.toValidationErrorMsg()));
            (0, loggingActions_1.screenLoadSuccess)(loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_LOGIN_FAILURE);
        });
    };
    (0, onKeyPress_1.default)("Enter", onSubmitLogin, null, password);
    const onSuccessLogin = (response) => {
        var _a, _b;
        (0, cookiesMember_1.setTicketCookies)(response.ticket);
        (0, cookiesMember_1.setMemberCookies)(response.member);
        if (checked) {
            setLocalStorage(constants_1.LocalStorageConstants.PHONE_NUMBER, flowState.phone);
        }
        else {
            setLocalStorage(constants_1.LocalStorageConstants.PHONE_NUMBER, "");
        }
        dispatch({
            screenType: "LOGIN_SUCCESS",
            successScreen: {
                title: (_a = response === null || response === void 0 ? void 0 : response.success) === null || _a === void 0 ? void 0 : _a.title,
                description: (_b = response === null || response === void 0 ? void 0 : response.success) === null || _b === void 0 ? void 0 : _b.description,
                withAddPost: true,
            },
            memberData: response.member
        });
        (0, loggingActions_1.authenticateLoginSuccessAction)(response.member.id);
        (0, slrActions_2.loggingAttemptUserClick)((0, helpers_2.createSlrLoggingBody)(flowState === null || flowState === void 0 ? void 0 : flowState.phone, "AttemptLoginPassword", ssoConfiguration));
    };
    const onForgetPassword = () => {
        dispatch({
            screenType: "FORGOT_PASSWORD",
            flow_type: constants_1.LoginAndRegistrationOtpActions.ACTION_FORGET_PASSWORD,
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "passwordScreen" }, (0, helpers_1.classNames)(isDesktop && "width-460 border radius-8 overflowHidden"), { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)("p-16 whiteBg", isMobile && "pt-0"), { children: [(0, jsx_runtime_1.jsx)("strong", Object.assign({ className: "block mb-8 font-24" }, { children: translations.password })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "font-14" }, { children: translations.pleaseFill + " " + translations.password }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "grayBg p-16" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "whiteBg p-16 radius-8 fullShadow mb-16" }, { children: [(0, jsx_runtime_1.jsx)(Field_1.default, { type: "tel", label: translations.mobileNumber, error: "", value: flowState === null || flowState === void 0 ? void 0 : flowState.phone, disabled: true }), (0, jsx_runtime_1.jsx)(Field_1.default, { type: "password", label: translations.password, onChangeCb: (value) => setPassWord(value), onClearCb: () => setPassWord(""), value: password, error: error["password"], autoFocus: true, withTrimSpaces: false })] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex flexSpaceBetween alignItems mb-16" }, { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ className: "linkColor underline font-15 noRipple", onClick: () => {
                                    (0, loggingActions_1.authenticateForgotpasswordClickAction)();
                                    onForgetPassword();
                                    (0, slrActions_1.gtmForgetPassBtn_SLRLoginScreen)();
                                } }, { children: translations.forgetPassword })), (0, jsx_runtime_1.jsxs)(FakedCheckbox_1.default, Object.assign({ setChecked: setChecked, checked: checked }, { children: [" ", translations.rememberMe] }))] })), (0, jsx_runtime_1.jsx)("button", Object.assign({}, (0, helpers_1.classNames)("blueBtn font-17 p-20", (password === null || password === void 0 ? void 0 : password.length) < 1 && "disabled"), { onClick: () => {
                            onSubmitLogin();
                            (0, slrActions_1.gtmNextBtn_SLRLoginScreen)();
                        }, "data-id": "nextButtonPassword" }, { children: translations.next }))] }))] })));
};
exports.default = PasswordScreen;
